import {
  AddCportalUserRequest,
  CportalServiceItem,
  SendCportalEmailRequest,
  FetchCportalUserAccountRequest,
  DeactivateCportalUserRequest,
  SetClientAccountCportalServiceRequest,
} from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { api } from '@/services/api.config';

export default function useCportal() {
  const source = axios.CancelToken.source();

  const [accountServices, setAccountServices] = useState<CportalServiceItem[]>([]);
  const [clientAccountServices, setClientAccountServices] = useState<CportalServiceItem[]>([]);
  const [isFetchingClientAccountServices, setIsFetchingClientAccountServices] = useState(false);
  const [cPortalLink, setCPortalLink] = useState('');
  const [active, setActive] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const addCportalUser = async (request: AddCportalUserRequest) => {
    try {
      const res = await api.addCportalUser(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const fetchAccountCportalSettings = async () => {
    try {
      const res = await api.fetchAccountCportalSettings(source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      if (res?.Services) {
        setAccountServices(res.Services);
      }

      if (res?.cPortalLink) {
        setCPortalLink(res.cPortalLink);
      }

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const fetchClientAccountServices = async (clientAccountID: string) => {
    try {
      setIsFetchingClientAccountServices(true);
      const res = await api.fetchClientAccountCportalServices({ ClientAccountID: clientAccountID }, source);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setClientAccountServices(res.Services);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setIsFetchingClientAccountServices(false);
    }
  };

  const setClientAccountService = async (request: SetClientAccountCportalServiceRequest) => {
    try {
      const res = await api.saveClientAccountCportalService(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const sendCportalEmail = async (request: SendCportalEmailRequest) => {
    try {
      const res = await api.sendCportalEmail(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const deactivateCportalUser = async (request: DeactivateCportalUserRequest) => {
    try {
      const res = await api.deactivateCportalUser(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const fetchUserAccount = async (request: FetchCportalUserAccountRequest) => {
    try {
      const res = await api.fetchCportalUserAccount(request);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setActive(res.User.IsActive);

      return res;
    } catch (err) {
      console.error(err);

      throw err;
    }
  };

  return {
    active,
    accountServices,
    clientAccountServices,
    isFetchingClientAccountServices,
    cPortalLink,
    addCportalUser,
    fetchAccountCportalSettings,
    fetchClientAccountServices,
    setClientAccountService,
    sendCportalEmail,
    deactivateCportalUser,
    fetchUserAccount,
  };
}
